import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { ReactComponent as PointLogoSVG } from 'assets/icon/point_system_logo.svg';
import { stylePropType } from 'utils/propTypes';

/**
 * 點數 Icon
 * @param {object} iconStyle - 預設點數 icon 樣式
 * @param {object} pointIconStyle - 點數樣式設定
 * @property {string} pointIconStyle.customImgUrl - 點數池的點數 Icon 自定義圖片 Url
 * @property {string} pointIconStyle.isUseCustomImg - 點數池的點數 Icon 是否啟用自定義圖片 Url
 * @property {string} pointIconStyle.iconColor - 點數池的點數 Icon 背景顏色
 *
 */
export default function PointIcon({
    pointIconStyle = {},
    themeStyle = {},
    size,
    style,
    partnerPointIconUrl,
    sponsorPointIconUrl
}) {
    const { customImgUrl, isUseCustomImg } = pointIconStyle;
    const customSystemIconUrl = Boolean(sponsorPointIconUrl)
        ? sponsorPointIconUrl
        : partnerPointIconUrl;

    return isUseCustomImg || Boolean(customSystemIconUrl) ? (
        <img
            src={Boolean(customSystemIconUrl) ? customSystemIconUrl : customImgUrl}
            css={css([customImgStyle(size), style])}
            alt="point-icon"
        />
    ) : (
        <PointLogoSVG css={[customThemeStyle(pointIconStyle, themeStyle, size), style]} />
    );
}

const customThemeStyle = (pointIconStyle, themeStyle, size) => css`
    width: ${size}px;
    height: ${size}px;

    .point_bg {
        fill: ${pointIconStyle.iconColor};
    }
    .point_text {
        fill: ${themeStyle.bgColor};
    }
`;

const customImgStyle = size => css`
    width: ${size}px;
    height: ${size}px;
    margin-right: 6px;
    position: relative;
`;

PointIcon.propTypes = {
    pointIconStyle: PropTypes.shape({
        color: PropTypes.string,
        iconImageUrl: PropTypes.string,
        cdnIconImageUrl: PropTypes.string
    }),
    size: PropTypes.number,
    style: stylePropType
};
